import * as _ from 'lodash';
import * as localRunnerCache from './runnerFileCache';
import * as servicesApi from './testimServicesApi';
import { promiseMap } from '../utils';
import type { RunnerOptions } from '../runOptions';
import type { TestBundle } from 'clickim/src/common/api/testimTestApi';

const TEN_HOURS = 1000 * 60 * 60 * 10;

export async function preloadTests(options: RunnerOptions): Promise<Record<string, TestBundle>> {
    if (!Array.isArray(options.testId) || !options.testId.length) {
        return {};
    }
    const opts = {
        branch: options.branch,
        projectId: options.project,
    };
    return await localRunnerCache.memoize(async () => {
        const results = await promiseMap(options.testId, testId => servicesApi.loadTest({ ...opts, testId }), { concurrency: 2 });
        return _.keyBy(results, 'testData.id');
    }, 'loadTests', TEN_HOURS, [opts, options.testId])();
}
